/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest } from "utils/request";

import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { putRequest } from "utils/request";

import { i18n } from '../../translate/i18n';
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";

export default function SkuteConfig() {
  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState("");
  const [previewBanner, setPreviewBanner] = useState("");
  const [about, setAbout] = useState("");
  const { toggleHelperId} = useModal();

  const { selectedCompany } = useNotification(); 

  useEffect(() => {
    setLoading(true);
    // setAbout(EditorState.createEmpty());

    async function GetConfigs() {
      //BUSCA DADOS CONFIG SKUTE POR EMPRESA
      const ReturnGet = await getRequest(
        `/skute/config?CompanyId=${selectedCompany.id}`
      );
      
      if (ReturnGet.success) {
        setPreviewBanner(ReturnGet.data.pathBanner);

        // const html = ReturnGet.data.about;

        const blocksFromHtml = convertFromHTML(ReturnGet.data.about);

        const { contentBlocks, entityMap } = blocksFromHtml

        if (contentBlocks) {
          const contentState = ContentState.createFromBlockArray(
            contentBlocks, ' '
          );

          const editorState = EditorState.createWithContent(contentState);

          setAbout(editorState);
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    }

    GetConfigs();

    toggleHelperId(19);
  }, [selectedCompany.id]);

  const handleUploadBanner = (file) => {
    setPreviewBanner(URL.createObjectURL(file.target.files[0]));
    setBanner(file.target.files[0]);
  };

  function onEditorStateChange(editorState) {
    setAbout(editorState);
  }

  const sendData = () => {
    setLoading(true);

    //Converte para String com as tags HTML
    let convertAbout = draftToHtml(convertToRaw(about.getCurrentContent()));

    const formData = new FormData();
    formData.append("about", convertAbout);
    formData.append("banner", banner);
    formData.append("CompanyId", selectedCompany.id);

    putRequest(`/skute/config?CompanyId=${selectedCompany.id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(function (response) {
        setLoading(false);
      }
    )
  };

  return (
    <>
      <div className="col-12">
        <div className="card">
          <div className="card-body" style={{ overflowY: "auto" }}>
            {!loading ? (
              <form
                className="form-edit"
                onSubmit={(e) => {
                  e.preventDefault();
                  sendData();
                }}
              >
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <h3>{i18n.t('Sobre')}</h3>
                    <Editor
                      editorState={about}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      onEditorStateChange={onEditorStateChange}
                      editorStyle={{
                        height: "25vh",
                        border: "1px solid #f3f3f3",
                        padding: 15,
                      }}
                    />
                  </div>
                </div>

                <div
                  className="form-row"
                  style={{
                    marginTop: 20,
                  }}
                >
                  <div className="form-group col-md-4">
                    <label>Banner</label>
                    <input
                      type="file"
                      className="form-control-file"
                      onChange={handleUploadBanner}
                    />
                  </div>

                  <div className="area-img-company-logo-config">
                    {previewBanner ? (
                      <img
                        src={previewBanner}
                        className="img-company-banner-skute-config"
                        style={{ maxHeight: 90, maxWidth: 200 }}
                        alt="banner"
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div
                  className="button-list mt-3 pull-right"
                  style={{ position: "absolute", bottom: 15, right: 15 }}
                >
                  <button type="submit" className="btn btn-outline-success">
                    <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
                  </button>
                </div>
              </form>
            ) : (
              <div className="area-loading">
                <CircularProgress />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
